import React, { ComponentProps } from 'react'
import { Layout } from 'components/Layout'
import { Header } from 'components/Header'
import { Footer } from 'components/Footer'
import { Statistics } from 'features/Recipes/components/Statistics'
import { ReviewsRoot } from './Reviews.styles'
import { Hero } from './components/Hero'
import { ThePack } from './components/ThePack'
import { TrustpilotSection } from './components/TrustpilotSection'
import { Comments } from './components/Comments'
import { CtaFooter } from 'features/Home/components/CtaFooter'

type ReviewsOwnProps = ComponentProps<typeof ReviewsRoot>
export type ReviewsProps = ReviewsOwnProps & {}

export const Reviews = (_props: ReviewsProps) => {
  const header = <Header />

  return (
    <ReviewsRoot>
      <Layout hideCTA header={header}>
        <Hero />
        <TrustpilotSection />
        <Statistics />
        <ThePack />
        <Comments />
        <CtaFooter title='reviews:awesomer.title' />
        <Footer />
      </Layout>
    </ReviewsRoot>
  )
}
